import {
    LOADMORE_SET_PAGINATION_INFO,
    LOADMORE_SET_LOADED,
} from '../constants';

const defaultState = {
    currentPageIndex: 1,
    loaded: true,
};

export const loadMore = (state = defaultState, action) => {
    const { type, payload } = action;

    switch (type) {
        case LOADMORE_SET_PAGINATION_INFO:
        case LOADMORE_SET_LOADED:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};
